import { Component, Input } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';

import { IFundProfileModel } from '../../../funds/models/fund-profile.model';
import { DecimalPipe } from '@angular/common';

@Component({
  selector: 'app-price-unit',
  templateUrl: './price-unit.component.html',
  styleUrls: ['./price-unit.component.scss'],
  standalone: true,
  imports: [MatTooltipModule, DecimalPipe],
})
export class PriceUnitComponent {
  @Input() sectionType = 'BUY';
  @Input() data!: IFundProfileModel;
  @Input() onlineNav!: number;
  @Input() unitCount?: number;
  @Input() description?: string;
}
